exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".mid-menu[data-v-2d00b9b8],.no-menu[data-v-2d00b9b8]{padding-top:0}.full-menu[data-v-2d00b9b8]{padding-top:8.15rem}@media (max-width:991.98px){.full-menu[data-v-2d00b9b8]{padding-top:5.15rem}}.username[data-v-2d00b9b8]{position:absolute;right:20px;bottom:5px}.catalog[data-v-2d00b9b8]{position:absolute;right:200px;width:120px;height:38px;color:#fff;border:0;background-color:#d72429}.catalogoption[data-v-2d00b9b8]{font-size:.8em;font-weight:400}.close[data-v-2d00b9b8]{z-index:10;padding-top:60px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2d00b9b8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["./scss/calia/_wp_variables.scss","./node_modules/bootstrap/scss/_mixins.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/custom/calia/start.vue
// module id = 1365
// module chunks = 172